<template>
  <div class="evaluate">
    <Header class="get-header" titles="选择标签" />
    <div class="text">
      <!-- <div class="text-title">详细评价</div> -->
      <Field
        class="text-field"
        v-model="als.content"
        rows="2"
        autosize
        type="textarea"
        maxlength="100"
        placeholder="请根据任务完成情况进行评价"
        show-word-limit
      />
    </div>
    <div class="tips">请根据任务完成情况进行评价</div>
    <div class="choose">
      <div class="choose-row">
        <div class="choose-row__title">专业技能</div>
        <Rate v-model="als.ability_score" allow-half void-icon="star" :size="26" void-color="#eee" />
      </div>
      <div class="choose-row">
        <div class="choose-row__title">工作效率</div>
        <Rate v-model="als.efficiency_score" allow-half void-icon="star" :size="26" void-color="#eee" />
      </div>
      <div class="choose-row">
        <div class="choose-row__title">责任心</div>
        <Rate v-model="als.responsibility_score" allow-half void-icon="star" :size="26" void-color="#eee" />
      </div>
      <div class="choose-row">
        <div class="choose-row__title">沟通能力</div>
        <Rate v-model="als.communicate_score" allow-half void-icon="star" :size="26" void-color="#eee" />
      </div>
      <div class="choose-row">
        <div class="choose-row__title">工作结果</div>
        <Rate v-model="als.result_score" allow-half void-icon="star" :size="26" void-color="#eee" />
      </div>
    </div>
    <div class="button" @click="upEva">提交</div>
  </div>
</template>

<script>
import Header from '@/components/header'
import { evaluateTask } from '@/api/api/task'
import { Rate, Field, Toast } from 'vant'
export default {
  data() {
    return {
      als: {
        task_id: 0,
        content: '',
        ability_score: 0,
        efficiency_score: 0,
        responsibility_score: 0,
        communicate_score: 0,
        result_score: 0
      }
    }
  },
  components: {
    Header,
    Rate,
    Field
  },
  methods: {
    upEva() {
      if (this.als.ability_score <= 0) return Toast('请评分专业技能')
      if (this.als.efficiency_score <= 0) return Toast('请评分工作效率')
      if (this.als.responsibility_score <= 0) return Toast('请评分责任心')
      if (this.als.communicate_score <= 0) return Toast('请评分沟通能力')
      if (this.als.communicate_score <= 0) return Toast('请评分工作结果')
      if (this.als.content.length < 5) return Toast('评价内容应大于5个字符')
      this.als.task_id = this.$route.query.task_id
      evaluateTask(this.als).then(res => {
        if (res.data.errorCode === 0) {
          Toast('提交成功')
          setTimeout(() => {
            this.$router.go(-1)
          }, 1000)
        }
      })
    }
  }
}
</script>

<style lang="scss">
.evaluate {
  letter-spacing: 0px;
  color: #333333;
  padding-top: 45px;
  min-height: 100%;
  .button {
    text-align: center;
    line-height: 46px;
    margin: 30px auto 0;
    height: 46px;
    border-radius: 5px;
    width: 80%;
    color: white;
    background-color: #4464EB;
  }
  .text {
    padding: 10px 30px;
    .text-field {
      border: 1px solid #ccc;
    }
    .text-title {
      font-weight: 600;
      padding: 29px 0 20px;
    }
  }
  .tips {
    font-weight: 600;
    padding-top: 30px;
    padding-left: 30px;
  }
  .choose {
    padding-top: 25px;
    padding-bottom: 30px;
    border-bottom: 1px solid #eee;
    .choose-row {
      padding: 0 30px 14px;
      color: #999999;
      display: flex;
      align-items: center;
      .choose-row__title {
        width: 70px;
      }
    }
  }
}
</style>